// useDocument.js
import { useState, useEffect } from "react";
import * as XLSX from "xlsx";
import useApi from "../useApi"; // Adjust the path as necessary
const processExcelData = (sheetsData) => {
    let maxContentColumnIndex = 0;
    let lastContentRowIndex = 0;
    sheetsData.forEach((row, rowIndex) => {
        let isRowEmpty = true;
        row.forEach((cell, index) => {
            if (
                cell !== null &&
                cell !== undefined &&
                cell.toString().trim() !== ""
            ) {
                isRowEmpty = false; // Found a non-empty cell, mark row as not empty
                if (index > maxContentColumnIndex) {
                    maxContentColumnIndex = index;
                }
                if (rowIndex > lastContentRowIndex) {
                    lastContentRowIndex = rowIndex;
                }
            }
        });
    });

    // Filter out the empty rows at the end and slice the rows to include only up to the max content column
    return sheetsData
        .slice(0, lastContentRowIndex + 1)
        .map((row) => row.slice(0, maxContentColumnIndex + 1));
};

const useDocument = (projectId, packageId, subcontractorId, documentId) => {
    const [fileType, setFileType] = useState("");
    const [file, setFile] = useState(null);
    const [excelData, setExcelData] = useState([]);
    const [{ data, loading, error }, callApi] = useApi();
    const loadAndProcessExcel = (fileURL) => {
        fetch(fileURL)
            .then((res) => res.arrayBuffer())
            .then((buffer) => {
                const workbook = XLSX.read(buffer, { type: "buffer" });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                const rawData = XLSX.utils.sheet_to_json(worksheet, {
                    header: 1,
                    defval: "",
                    raw: false,
                });
                const processedData = processExcelData(rawData);
                console.log(processedData);
                console.log(rawData);
                setExcelData(processedData); // Update the state with the processed Excel data
            })
            .catch((err) => console.error(err));
    };
    useEffect(() => {
        callApi({
            url: `/api/projects/${projectId}/packages/${packageId}/subcontractors/${subcontractorId}/documents/${documentId}`,
            responseType: "blob",
        });
    }, [projectId, packageId, subcontractorId, documentId]);

    useEffect(() => {
        if (data) {
            const fileURL = URL.createObjectURL(data);
            const currentFileType = data.type.includes("pdf") ? "pdf" : "excel";
            setFileType(currentFileType);
            setFile(fileURL);

            if (currentFileType === "excel") {
                loadAndProcessExcel(fileURL);
            }
        }
    }, [data]);

    return { fileType, file, excelData, loading, error };
};

export default useDocument;
